export default __webpack_public_path__ + "static/media/map1_icon.873767ea.svg";